var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import * as PropTypes from 'prop-types';
function DpiContainer(props) {
    return (React.createElement("div", { className: 'd-block d-md-flex align-items-center justify-content-center' },
        React.createElement("div", { className: 'text-white' },
            React.createElement("h5", { className: 'mb-2 mt-0' }, "Cookie Policy"),
            React.createElement("p", { className: 'mr-0 mr-md-5 mb-0 hyphens-auto ' },
                React.createElement("small", null,
                    "This website uses cookies to improve our site\u2019s user-friendliness and to measure where our visitors come from. By continuing to use our website, you agree to our use of cookies. You can find more information about our\u00A0",
                    React.createElement("a", { className: 'link-single-internal text-white font-weight-bold', href: 'https://www.hetzner.com/rechtliches/datenschutz/' },
                        "privacy policies",
                        React.createElement("i", { className: 'fas fa-angle-right ml-1' }))))),
        React.createElement("button", { id: 'btn-agree-cookie', className: 'btn btn-sm btn-primary text-nowrap mt-3 mt-md-0', onClick: props.onClick }, "Yes, I agree")));
}
DpiContainer.propTypes = { onClick: PropTypes.func };
var HOCookieBanner = /** @class */ (function (_super) {
    __extends(HOCookieBanner, _super);
    function HOCookieBanner(props) {
        var _this = _super.call(this, props) || this;
        var isCookieSet = _this.isCookieSet();
        _this.state = {
            show: !isCookieSet,
            cookiesAccepted: false
        };
        return _this;
    }
    HOCookieBanner.getCookie = function (name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) {
            return match[2];
        }
        return null;
    };
    HOCookieBanner.setCookie = function (cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    };
    HOCookieBanner.prototype.isCookieSet = function () {
        if (!this.isCookieNameValid()) {
            return true;
        }
        var cookieValue = HOCookieBanner.getCookie(this.props.cookieName);
        return cookieValue === 'allow';
    };
    HOCookieBanner.prototype.isCookieNameValid = function () {
        return this.props.cookieName !== '';
    };
    HOCookieBanner.prototype.onClickAgree = function () {
        var _this = this;
        if (!this.isCookieNameValid()) {
            return;
        }
        HOCookieBanner.setCookie(this.props.cookieName, 'allow', 365);
        this.setState({ show: false }, function () {
            _this.props.setCookiesAccepted(true);
        });
    };
    HOCookieBanner.prototype.render = function () {
        if (!this.state.show) {
            return null;
        }
        return (React.createElement("div", { id: 'dpi-banner', className: 'dpi-banner w-100 h-auto bg-black color-white px-2 py-3' },
            React.createElement("div", null, this.state.cookiesAccepted && (React.createElement("noscript", null,
                React.createElement("iframe", { src: 'https://www.googletagmanager.com/ns.html?id=GTM-598VVLT', height: '0', width: '0', style: { display: 'none', visibility: 'hidden' } })))),
            React.createElement(Container, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 },
                        React.createElement(DpiContainer, { onClick: this.onClickAgree }))))));
    };
    return HOCookieBanner;
}(React.Component));
export { HOCookieBanner, DpiContainer };
